var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:['header-links', 'text-xs-center']},_vm._l((_vm.headerMenu),function(link,index){return _c('li',{key:index},[_c('v-btn',{class:['ma-0'],attrs:{"to":link.url,"title":link.hint,"flat":"","large":""}},[_vm._v(_vm._s(link.label))])],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d0cac9f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header-links.vue
// module id = null
// module chunks = 